    (function () {
        const TEST_ID = "MMI9";
        const VARIANT_ID = "V1";

        function logInfo(message) {
            console.log(
                `%cAcadia%c${TEST_ID}-${VARIANT_ID}`,
                "color: white; background: rgb(0, 0, 57); font-weight: 700; padding: 2px 4px; border-radius: 2px;",
                "margin-left: 8px; color: white; background: rgb(0, 57, 57); font-weight: 700; padding: 2px 4px; border-radius: 2px;",
                message
            );
        }

        logInfo("fired");

        const globalVariables = {
            testName: "MMI9",
            pageInitials: "ab-MMI9",
            testVariation: 1,
        };

        function waitForElem(predicate, callback, timer = 15000, frequency = 100) {
            if (timer <= 0) return;
            if (typeof predicate === "function" && predicate()) {
                callback();
            } else {
                setTimeout(
                    () => waitForElem(predicate, callback, timer - frequency),
                    frequency
                );
            }
        }

        function fireGA4Event(eventName, eventLabel = "") {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "GA4event",
                "ga4-event-name": "cro_event",
                "ga4-event-p1-name": "event_category",
                "ga4-event-p1-value": eventName,
                "ga4-event-p2-name": "event_label",
                "ga4-event-p2-value": eventLabel,
            });
        }

        const testAssets = {
            tikIcon: `<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 7.5C15 9.48912 14.2098 11.3968 12.8033 12.8033C11.3968 14.2098 9.48912 15 7.5 15C5.51088 15 3.60322 14.2098 2.1967 12.8033C0.790176 11.3968 0 9.48912 0 7.5C0 5.51088 0.790176 3.60322 2.1967 2.1967C3.60322 0.790176 5.51088 0 7.5 0C9.48912 0 11.3968 0.790176 12.8033 2.1967C14.2098 3.60322 15 5.51088 15 7.5ZM11.2781 4.65937C11.2112 4.59264 11.1314 4.5401 11.0437 4.50489C10.9559 4.46968 10.862 4.45252 10.7675 4.45445C10.673 4.45637 10.5798 4.47734 10.4936 4.5161C10.4073 4.55485 10.3298 4.6106 10.2656 4.68L7.00969 8.82844L5.0475 6.86531C4.91421 6.74111 4.73792 6.6735 4.55576 6.67671C4.3736 6.67992 4.1998 6.75372 4.07098 6.88254C3.94215 7.01137 3.86836 7.18517 3.86515 7.36732C3.86193 7.54948 3.92955 7.72577 4.05375 7.85906L6.53437 10.3406C6.6012 10.4073 6.68078 10.4599 6.76836 10.4952C6.85594 10.5305 6.94973 10.5477 7.04414 10.546C7.13854 10.5442 7.23163 10.5235 7.31784 10.485C7.40405 10.4465 7.48163 10.391 7.54594 10.3219L11.2884 5.64375C11.416 5.51109 11.4865 5.3337 11.4848 5.14965C11.483 4.9656 11.4092 4.78958 11.2791 4.65937H11.2781Z" fill="#04A188"/>
    </svg>`
        };

        let observerInstance = null;

        const init = () => {
            const headerContainer = document.querySelector('nav.header .header__container');
            if (headerContainer) {
                headerContainer.addEventListener('click', (e) => {
                    const cartIcon = e.target.closest('.cart-menu .cart-icon');
                    if (cartIcon) {
                        fireGA4Event('MMI9_ViewCart');
                    }
                });
            }

            const hybridCart = document.querySelector("ns-hybrid-cart");
            if (!hybridCart) {

                return;
            }

            setTimeout(() => {
                const shadowRoot = hybridCart.shadowRoot;
                if (!shadowRoot) {

                    return;
                }

                const applyChanges = () => {
                    const target = shadowRoot.querySelector("shop-pay-wallet-button")?.parentElement;

                    if (!target) {return}

                    if (target.classList.contains("online-payment-methods")) {return}

                    target.classList.add("online-payment-methods");

                    if (!shadowRoot.querySelector("style[data-mmi9]")) {
                        const style = document.createElement("style");
                        style.setAttribute("data-mmi9", "true");
                        style.textContent = `
                            .online-payment-methods { 
                                display: none !important; 
                            }
                            .money-back-prop-wrapper {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                margin-top: 9px;
                                margin-bottom: 11px;
                            }
                            .money-back-prop-wrapper .money-back-prop {
                                font-family: Circular, sans-serif;
                                font-weight: 450;
                                font-size: 12px;
                                line-height: 100%;
                                letter-spacing: 0;
                                display: flex;
                                align-items: center;
                                margin: 0;
                            }
                            .money-back-prop-wrapper svg {
                                height: 15px;
                                width: 15px;
                                margin-right: 3px;
                            }
                        `;
                        shadowRoot.appendChild(style);
                    }

                    if (!shadowRoot.querySelector('.money-back-prop-wrapper')) {
                        target.insertAdjacentHTML("afterend", `
                        <div class="money-back-prop-wrapper">
                        ${testAssets.tikIcon}
                        <p class="money-back-prop">100-Day Money-Back Guarantee</p>
                        </div>
                    `);
                    }
                };

                applyChanges();

                if (!observerInstance) {
                    observerInstance = new MutationObserver((mutations) => {
                        const hasRelevantChanges = mutations.some(mutation =>
                            mutation.type === 'childList' && mutation.addedNodes.length > 0
                        );

                        if (hasRelevantChanges) {
                            applyChanges();
                        }
                    });

                    observerInstance.observe(shadowRoot, {
                        childList: true,
                        subtree: true,
                    });

                }
            }, 100);
        };

        const hasAllElements = () => {
            const headerContainer = document.querySelector('nav.header .header__container');
            const hybridCart = document.querySelector("ns-hybrid-cart");
            const shadowRoot = hybridCart?.shadowRoot;
            const payButton = shadowRoot?.querySelector("shop-pay-wallet-button");

            return !!(headerContainer && hybridCart && shadowRoot && payButton);
        };

        const pageInitials = globalVariables.pageInitials;

        waitForElem(
            () => document.querySelector(`body:not(.${pageInitials})`) && hasAllElements(),
            () => {
                document.querySelector("body").classList.add(pageInitials);
                init();
            },
            20000,
            150
        );
    })();
